<template lang="html">
  <div class="bg" v-if="show">
    <div class="container">
      <div class="topline">
        <p class="title">选择审核人</p>
        <img src="@assets/img/common/close.svg" alt="close" @click="close()">
      </div>
      <empty :msg="'暂无审核人'" v-if="list.length === 0" />
      <div class="list" v-else>
        <div :class="{item: true, on: i.selected}" v-for="(i, d) in list" :key="d" @click="selectItem(i)">
          {{i.name}}
        </div>
      </div>
      <div class="footline">
        <div class="btn greenBtn" @click="confirm()">确定</div>
        <div class="btn" @click="cancel()">取消</div>
      </div>
    </div>
  </div>

</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import empty from '@components/empty'

export default {
  name: 'checkers',
  components: {
    empty
  },
  data() {
    return {
      show: false,
      list: [],
      id: '',
      handlePromise: null,
      handleResolve: null
    }
  },
  methods: {
    close() {
      this.show = false
    },
    cancel() {
      // 取消操作，关闭弹窗
      if (this.handleResolve) {
        this.handleResolve(false)
        this.handlePromise = null
      }

      this.close()
    },
    open(id) {
      this.id = id
      this.getlist(id)
      this.show = true

      this.handlePromise = new Promise((resolve) => {
        this.handleResolve = resolve
      })

      return this.handlePromise
    },
    getlist(id) {
      const info = {
        id: id
      }

      common.myFetch(apis.checker_list, info)
      .then(r => {
        if (r) {
          this.list = r.list
        }
      })
    },
    selectItem(i) {
      this.$set(i, 'selected', !i.selected)
    },
    getIds() {
      // 获取已选id
      return this.list.filter(i => {return i.selected}).map(j => {return j.id}).join(',')
    },
    confirm() {
      const ids = this.getIds()
      if (!ids) {
        this.$toast('没有选择审核人')
        this.cancel()
        return
      }

      const info = {
        report_id: this.id,
        verify_uid: ids
      }

      common.myFetch(apis.checker_add, info)
      .then(r => {
        if (r) {
          this.$toast(r)

          this.handleResolve(true)
          this.close()
        }
      })

    }
  },
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1111;
    .container {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      border-radius: 4px;
      background-color: #f9f9f9;
      overflow: hidden;
      width: 490px;
      height: 290px;
      padding: 20px 30px;
      display: flex;
      flex-direction: column;
      .topline {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;
        .title {
          font-size: 24px;
          color: @dark;
        }
        img {
          cursor: pointer;
        }
      }
      .list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        margin: 20px 0;
        overflow-y: auto;
        .item {
          min-width: 80px;
          height: 30px;
          padding: 0 10px;
          line-height: 30px;
          text-align: center;
          border-radius: 100px;
          border: 1px solid transparent;
          color: @sub;
          cursor: pointer;
          margin: 0 10px 30px 0;
        }
        .on {
          border-color: @green;
          color: @green;
        }
      }
      .footline {
        height: 40px;
        display: flex;
        justify-content: center;
        .greenBtn {
          background-color: @green !important;
          color: #fff !important;
          margin-right: 20px;
        }
        .btn {
          color: #fff;
          width: 120px;
          height: 40px;
          margin-left: 10px;
          line-height: 40px;
          border-radius: 100px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          background-color: @dateColor;
          &:hover {
            .btnHover;
          }
          &:active {
            .btnActive;
          }
        }
      }
    }
  }
</style>
